<template>
  <div class="chickenApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <div class="classInfo" v-for="(item,i) in setChicken" @click="toPush(item.id,'cdetail')">
      <div class="titles">
        <img :src="baseUrl+item.images"  mode="widthFix">
        <span >库存：{{item.stock - item.payTotal}}只</span>
      </div>
      <div class="teacher">
        <p>{{item.title}}</p>
        <span>基地：{{item.address}}</span>
        <span class="price">
          <font class="rates"><i>￥</i>{{item.rate}}<i> 起</i></font>
          <font>￥{{item.price}}</font>
        </span>
      </div>
    </div>

    <footComponent :idx='2'></footComponent>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        code:'',
        setChicken:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/chicken');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }
      this.getChicken();
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getChicken:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/chicken/index'
        }).then(function(response){
          var res = response.data;
          that.setChicken = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .chickenApp{
    background:#ebebeb
  }
  .chickenApp .classInfo{
    width:92%;
    background: #FFFFFF;
    border-radius: 10px;
    margin:0 auto 15px auto;
  }
  .chickenApp .classInfo .titles{
    position:relative;
  }
  .chickenApp .classInfo .titles span{
    position:absolute;
    width: 85px;
    height: 28px;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1000);
    border-radius: 28px 0px 0px 28px;
    right:0;
    bottom:50px;
    color: #f00;
    font-size: 14px;
    text-align:center;
    line-height: 28px;
  }
  .chickenApp .classInfo .titles img{
    width:100%;
    border-radius: 10px 10px 0 0;
  }
  .chickenApp .classInfo .teacher{
    width:92%;
    margin:0 auto;
    padding:0px 0 15px 0
  }
  .chickenApp .classInfo .teacher p{
    font-size: 32rpx;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    padding:5px 0 10px 0
  }
  .chickenApp .classInfo .teacher span{
    display:block;
    font-size: 14px;
    color: #666666;
  }

  .chickenApp .classInfo .teacher .price{
    color:#666;
    font-size:14px;
    padding-top:8px
  }
  .chickenApp .classInfo .teacher .price font{
    color:#000;
  }
  .chickenApp .classInfo .teacher .price font.rates{
    color:red;
    font-weight:bold;
    font-size:20px
  }
  .chickenApp .classInfo .teacher .price font i{
    font-size:10px;
    font-style:normal;
  }
  .chickenApp .classInfo .teacher .price font:last-child{
    text-decoration: line-through;
    padding-left:10px;
    color: #666666;
  }
</style>